module.exports = __webpack_public_path__ + "assets/ic_cart_minus-c16c82.svg";